import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';
import { IUpcomingAppointment } from '@folx-types/scheduledAppointments';

import BillingCancelMembership, {
	IBillingCancelMembershipPageContent,
} from './BillingCancelMembership.component';

interface IMedicationDeliveryPostSubmitPreferredPharmacyStepPageProps extends IPageProps {}

const MedicationDeliveryPostSubmitPreferredPharmacyStepPage: FC<
	IMedicationDeliveryPostSubmitPreferredPharmacyStepPageProps
> = ({ path, ...props }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-cancel-membership-confirmation-page" }) {
				third_paragraph
				cta_view_appointments
			}
		}
	`);

	const refinedContent: IBillingCancelMembershipPageContent = keysToCamel(
		pageContent
	) as IBillingCancelMembershipPageContent;

	return (
		<BillingCancelMembership
			pageContent={refinedContent}
			path={path}
			upcomingAppointments={props?.location?.state?.upcomingAppointments as IUpcomingAppointment[]}
		/>
	);
};

export default MedicationDeliveryPostSubmitPreferredPharmacyStepPage;
